import React, { useEffect, useRef } from "react";
import { Box, CircularProgress, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { disconnectWebsocket } from "../../../../store/actions/websocketActions";
import ComposeEmailForm from "../../../admin/email/ComposeEmailForm";

const EmailPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const currentUser = useSelector((state) => state[currentSession]?.user);
  const redirected = useRef(false);

  const isAdmin =
    currentUser?.user?.role === "admin" && !!currentUser?.user?.admin;

  useEffect(() => {
    if (currentUser && !isAdmin && !redirected.current) {
      redirected.current = true;
      dispatch(disconnectWebsocket(currentSession));
      navigate("/login");
    }
  }, [currentUser, isAdmin, currentSession, dispatch, navigate]);

  if (!isAdmin) {
    return (
      <Box
        sx={{
          display: "flex",
          width: "100%",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress color="warning" size="6rem" />
      </Box>
    );
  }

  return (
    <Box
      component="main"
      sx={{ flexGrow: 1, py: 3, backgroundColor: "#EEF2F6" }}
    >
      <Container maxWidth="lg">
        <Typography variant="h4" sx={{ mb: 3 }}>
          Email
        </Typography>
        <ComposeEmailForm currentSession={currentSession} />
      </Container>
    </Box>
  );
};

export default EmailPage;
